/**
 * StartNode - Modern entry point node
 */

import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { IconPlayerPlay } from '@tabler/icons-react';

const StartNode = ({ data }) => {
  return (
    <div className="afc-node afc-node-start">
      <div className="afc-node-glow" />
      <div className="afc-node-inner">
        <div className="afc-node-icon-wrapper start">
          <IconPlayerPlay size={20} stroke={1.5} />
        </div>
        <div className="afc-node-text">
          <span className="afc-node-label">{data.label}</span>
          <span className="afc-node-subtitle">{data.agentName}</span>
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        className="afc-handle afc-handle-source"
      />
    </div>
  );
};

export default memo(StartNode);
